<div *ngIf="isLoading" class="text-center my-4">
    <on-loading></on-loading>
</div>

<div *ngIf="!isLoading">
    <h2>{{ 'company.expense-types.title' | translate }}</h2>
    <p>{{ 'company.expense-types.description' | translate }}</p>
    <form>
        <div class="expense-types-table-container">
            <table class="table table-bordered table-sm">
                <thead>
                    <tr>
                        <th class="default-name-col">
                            {{
                                'company.expense-types.default-name' | translate
                            }}
                        </th>
                        <th>
                            {{
                                'company.expense-types.custom-name' | translate
                            }}
                        </th>
                        <th class="description-col">
                            {{
                                'company.expense-types.custom-description'
                                    | translate
                            }}
                            <small class="d-block text-muted fw-normal">
                                {{
                                    'company.expense-types.custom-description-helper'
                                        | translate
                                }}
                            </small>
                        </th>
                        <th>
                            {{ 'company.expense-types.visible' | translate }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let type of expenseTypeConfigurations">
                        <td class="default-name-col">
                            <span *ngIf="type.type.Icon" class="me-2"
                                ><nb-icon
                                    [icon]="'fa-' + type.type.Icon"
                                ></nb-icon
                            ></span>
                            {{
                                'db.expense-types.' + type.type.Code | translate
                            }}
                        </td>
                        <td>
                            <input
                                type="text"
                                class="form-control"
                                [(ngModel)]="type.customName"
                                [disabled]="type.isHidden"
                                name="customName-{{ type.type.Id }}"
                            />
                        </td>
                        <td class="description-col">
                            <textarea
                                class="form-control"
                                rows="2"
                                [(ngModel)]="type.description"
                                [disabled]="type.isHidden"
                                name="description-{{ type.type.Id }}"
                            ></textarea>
                        </td>
                        <td class="text-center">
                            <input
                                type="checkbox"
                                class="expense-type-checkbox"
                                [ngModel]="!type.isHidden"
                                (ngModelChange)="type.isHidden = !$event"
                                name="visible-{{ type.type.Id }}"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="save-btn-row">
            <button type="button" class="btn btn-primary" (click)="onSave()">
                {{ 'company.expense-types.save' | translate }}
            </button>
        </div>
    </form>
</div>
